import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {OrdersFilter} from '../models/orders-filter.model';
import {FilterService} from '@shared/models/filter-service.model';
import {Observable} from 'rxjs/Observable';

/**
 * Questo service serve per notificare e aggiorare il OrdersFilter
 * a tutti gli attori che ne hanno bisogno
 */

@Injectable()
export class OrdersFilterService implements FilterService {

	private filterSubject: Subject<OrdersFilter> = new Subject<OrdersFilter>();
	private filterObservable$: Observable<OrdersFilter> = this.filterSubject.asObservable();

	private currentFilter: OrdersFilter;
	private lastFilter: OrdersFilter;

	getFilterObservable(): Observable<OrdersFilter> {
		return this.filterObservable$;
	}

	updateFilter(filter: OrdersFilter): void {
		this.currentFilter = filter;
		this.filterSubject.next(filter);
		if (this.currentFilter !== null) {
			this.lastFilter = this.currentFilter;
		}
	}

	reloadLastFilter(): void {
		this.updateFilter(this.lastFilter);
	}

	getCurrentFilter(): OrdersFilter {
		return this.currentFilter;
	}

	getEmptyFilter(): OrdersFilter {
		return this.currentFilter = new OrdersFilter();
	}
}
